import { Effect, Layer } from "effect";
import { editorBaseTypeLibraries } from "./type-library-sources.ts";
import { editorWorkerConfiguration } from "./worker-configuration.ts";
import { editorModelDependencyFailure } from "./model.ts";
import { EditorProjectTypes } from "./project-service.ts";
export const editorProjectTypes = EditorProjectTypes.of({
  libraries: Effect.fn("Frontend.EditorProjectTypes.libraries")((files: Readonly<Record<string, string>>, authority: string, revision: number) => Effect.try({
    try: () => Object.fromEntries([
      ...editorBaseTypeLibraries.map(library => ["file://" + authority + "/" + library.path, { content: library.content, version: revision }] as const),
      ["file://" + authority + "/worker-configuration.d.ts", { content: editorWorkerConfiguration(files), version: revision }]
    ]),
    catch: editorModelDependencyFailure
  }))
});
export const EditorProjectTypesLive = Layer.succeed(EditorProjectTypes, editorProjectTypes);
